import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-leadcrm-layout',
  templateUrl: './leadcrm-layout.component.html',
  styleUrls: ['./leadcrm-layout.component.css']
})
export class LeadcrmLayoutComponent implements OnInit {

  headerColor = 'primary';
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));
  ecomNavItems = [];
  constructor(public authService : AuthService,     
    private breakpointObserver: BreakpointObserver,
    private router:Router,
    ) {
      this.ecomNavItems = [
        {
          displayName: 'Dashboard',
          iconName: 'dashboard',
          route: '/leadcrm',
        }, 
        {
          displayName: 'Leads',
          iconName: 'label_important',
          route: 'leadcrm/leads',
        },         
        {
          displayName: 'Settings',
          iconName: 'settings',
          route: 'leadcrm/settings',
          children: [
            {
              displayName: 'Leads Status',
              iconName: 'check_circle',
              route: 'leadcrm/settings/leads-status'
            },
            {
              displayName: 'SMS Template',
              iconName: 'sms',
              route: 'leadcrm/settings/sms-template'
            },
            {
              displayName: 'Email Template',
              iconName: 'email',
              route: 'leadcrm/settings/email-template'
            },
          ]
        }
      ];
     }

  ngOnInit() {
    
  }


}
